import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RESERVATION_AVAILABILITY_STORE_NAME, ReservationAvailabilityState } from './reservation-availability.state';

/** Select ReservationAvailability State */
export const selectReservationAvailabilityState = createFeatureSelector<ReservationAvailabilityState>(
  RESERVATION_AVAILABILITY_STORE_NAME
);

/** Select ReservationAvailability isPending status */
export const selectReservationAvailabilityIsPendingStatus = createSelector(
  selectReservationAvailabilityState,
  (state) => !!state.isPending
);

/** Select ReservationAvailability isFailure status */
export const selectReservationAvailabilityIsFailureStatus = createSelector(
  selectReservationAvailabilityState,
  (state) => !!state.isFailure
);

/** Select ReservationAvailability isFailure status */
export const selectReservationAvailability = createSelector(
  selectReservationAvailabilityState,
  (state) => state && state.model?.data
);
